// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../startOfWeek/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var startOfWeek = convertToFP(fn, 1);
export default startOfWeek;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/startOfWeek/index.js
// module id = 995
// module chunks = 0